const module = angular.module('app.lbaFareClassTypeSelect', []);

module.filter("fareClassType", () => (value) => {
    switch (value) {
        case "Economy":
            return "Economy";
        case "PremiumEconomy":
            return "Premium Economy";
        case "Business":
            return "Business";
        case "FirstClass":
            return "First Class";
        default:
            return "";
    }
});
module.controller('lbaFareClassTypeSelectCtrl', require('./lbaFareClassTypeSelectCtrl'));
module.directive('lbaFareClassTypeSelect', require('./lbaFareClassTypeSelectDir'));
module.service('fareClassTypeService', require('../../services/fareClassTypeService'));

export default module.name;



// WEBPACK FOOTER //
// ./src/components/lbaFareClassTypeSelect/index.js